<template>
    <li class="nav-item"  v-if="hasAccess">
        <router-link
                :to="link.path"
                @click.native="linkClick"
                class="nav-link"
                :target="link.target"
                :href="link.path">
            <template>
                <i :class="link.icon"></i>
                <span class="nav-link-text">{{ link.name }}</span>
            </template>
        </router-link>
    </li>
</template>
<script>
  export default {
    name: 'sidebar-item',
    props: {
      link: {
        type: Object,
        default: () => {
          return {
            name: '',
            path: '',
              children: [],
              roles: [] 
          };
        },
        description:
          'Sidebar link. Can contain name, path, icon and other attributes. See examples for more info'
      }
    },
    inject: {
      autoClose: {
        default: true
      }
    },
    data() {
      return {
        children: [],
        collapsed: true
      };
    },
    computed: {
      hasAccess() {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user || !user.role) {
          return false;
        }
        // Check if the link has roles defined and if the user's role is in the allowed roles
        if (this.link.roles && this.link.roles.length > 0) {
          return this.link.roles.includes(user.role);
        }
        return true; // If no roles are defined, allow access by default
      }
    },
    methods: {
      linkClick() {
        if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
        ) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>
